// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_styles_btn-primary__2-2Uu","inputLabelContainer":"_styles_inputLabelContainer__27hAF","inputLabel":"_styles_inputLabel__vyVUY","error":"_styles_error__2T7mI"};